// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchFilters_root__1zD1A","filtersWrapper":"SearchFilters_filtersWrapper__p4iIY","filtersInner":"SearchFilters_filtersInner__1BOlr","filter":"SearchFilters_filter__3_n9Z"};